import { DESIGNER_URL, COMPUTE_URL } from './__urlsSystem'
import { paramSpecs } from './_uiHelpers'

// construct various url's with productId and currentParams

export function computeUrl(productId, currentParams) {
	const url = makeUrl('computeid', productId, currentParams, COMPUTE_URL)
	// console.log('computeUrl', url)
	return url
}

export function paramsUrl(productId) {
	const url = makeUrl('getparams', productId, {}, COMPUTE_URL)
	return url
}

export function viewerUrl(productId, currentParams) {
	return makeUrl('viewer', productId, abbreviateParams(productId, currentParams), DESIGNER_URL)
}

export function saveUrl(productId, currentParams) {
	const url = makeUrl('config', productId, abbreviateParams(productId, currentParams), DESIGNER_URL)
	return url
}

export function saveQueryParams(productId, currentParams) {
	const url = makeQueryParams(abbreviateParams(productId, currentParams))
	return url
}

export function configPresetUrl(productId) {
	const url = makeUrl('config', productId, {}, COMPUTE_URL)
	return url.pathname
}

export function arUrl(productId, currentParams) {
	const url = makeUrl('ar', productId, abbreviateParams(productId, currentParams), DESIGNER_URL)
	return url
}

// Note: the url will be an abbreviated url or an unabbreviated url, depending on the provided currentParams
function makeUrl(path, productId, currentParams, serverUrl) {
	const url = new URL(`/${path}/${productId}`, serverUrl)
	Object.keys(currentParams).forEach((key) => url.searchParams.append(key, currentParams[key]))
	// console.log('makeUrl', url)
	return url
}

function makeQueryParams(currentParams) {
	const params = Object.keys(currentParams).map((key) => `${key}=${currentParams[key]}`)
	return params.join("&");
}

///////////////////////////////////////////////////////////////////////////////////////////
// convert between abbreviated and unabbreviated parameter names
//
// We create two types of urls: abbreviated and unabbreviated.
// If the user ever sees the url, we use the abbreviated version.
// For communication with the middleware server, we use the unabbreviated version.
//
// The caller of these functions always knows whether the currentParams are abbreviated or not.
///////////////////////////////////////////////////////////////////////////////////////////

export function abbreviateParams(productId, currentParams) {
	const specs = paramSpecs(productId)

	const mapping = {} // convenient object of a set of object pairs: {rhinoName: abbrev}
	specs.forEach((param) => (mapping[param.rhinoName] = param.abbrev))

	const encoded = {} // an encoded version of currentParams
	Object.entries(currentParams).forEach(([key, value]) => (encoded[mappedKey(key, mapping)] = value))
	// console.log('encoded', encoded)
	return encoded
}

export function unabbreviateParams(productId, incomingParamsEncoded) {
	const specs = paramSpecs(productId)

	const mapping = {} // convenient object of a set of object pairs: {rhinoName: abbrev}
	specs.forEach((param) => (mapping[param.abbrev] = param.rhinoName))

	const decoded = {} // a decoded version of currentParams
	Object.entries(incomingParamsEncoded).forEach(([key, value]) => (decoded[mappedKey(key, mapping)] = value))
	// console.log('decoded', decoded)
	return decoded
}

function mappedKey(key, mapping) {
	// if (mapping[key] === undefined) console.log('abbrev missing', key)
	return mapping[key] === undefined ? key : mapping[key]
}

// This is currently unused, but will be useful in the future when we need to handle unknown params (e.g., json objects) from partners
export function findUnknownParams(productId, incomingParamsEncoded) {
	const incomingParamNames = Object.keys(unabbreviateParams(productId, incomingParamsEncoded)) // just the param names
	const specs = paramSpecs(productId) // find all rhinoNames for this productId
	const knownParams = specs.map((spec) => spec.rhinoName)
	// find the param names that are NOT officially known for this product (i.e., not in params.txt)
	const unknownParamNames = incomingParamNames.filter((key) => !knownParams.includes(key))
	// get the key/value pairs for the unknown params
	const unknownParams = Object.fromEntries(
		Object.entries(incomingParamsEncoded).filter(([key, value]) => unknownParamNames.includes(key))
	)
	// console.log('unknownParams', unknownParams)
	return unknownParams
}


